import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import './OrderConfirmation.css';
import Footer from '../Footer/Footer';

function OrderConfirmation() {

    const location = useLocation();
    // const orderId = location.state?.orderId;
    const { orderId, address } = location.state || {};
    const navigate = useNavigate();


  return (
    <>
        <Navbar/>
        <div className="sticky-navbar">
            <Navbar2/>
        </div>

        <div className="container py-5 text-center">
            <h2>Order Confirmation</h2>
            <div className="alert alert-success mt-4">
                <h4>Thank you for your order!</h4>
                <p>Your order number is: <strong>{orderId}</strong></p>
                <p>We've sent a confirmation email with your order details.</p>
            </div>

            <Link to='/' className='btn btn-primary mt-3'>
                Continue Shopping
            </Link>
            <button  className='btn btn-primary mt-3'
            onClick={() => navigate('/track-order', { state: { orderId: location.state.orderId } })}
            >
                Track Your Order
            </button >
        </div>

        <Footer/>
    </>
  )
}

export default OrderConfirmation